import { Type } from '@angular/core'
import { CheckboxPlaceholderComponent } from './checkbox-placeholder/checkbox-placeholder.component'
import { DataDicPlaceholderComponent } from './data-dic-placeholder/data-dic-placeholder.component'
import { FieldPlaceholderComponent } from './field-placeholder.component'
import { InitialsPlaceholderComponent } from './initials-placeholder/initials-placeholder.component'
import { PrefillFieldPlaceholderComponent } from './prefill-field-placeholder/prefill-field-placeholder.component'
import { SignaturePlaceholderComponent } from './signature-placeholder/signature-placeholder.component'
import { SigndatePlaceholderComponent } from './signdate-placeholder/signdate-placeholder.component'
import { TextboxPlaceholderComponent } from './textbox-placeholder/textbox-placeholder.component'
import { SignFieldType } from '@tokeet-frontend/signature'

export const signFieldComponents: Record<SignFieldType, Type<FieldPlaceholderComponent>> = {
  signature: SignaturePlaceholderComponent,
  initials: InitialsPlaceholderComponent,
  checkbox: CheckboxPlaceholderComponent,
  textbox: TextboxPlaceholderComponent,
  signdate: SigndatePlaceholderComponent,
  datadic: DataDicPlaceholderComponent,
  prefill: PrefillFieldPlaceholderComponent,
}
